import { render, staticRenderFns } from "./updateLiquidationModel.vue?vue&type=template&id=68199f67&"
import script from "./updateLiquidationModel.vue?vue&type=script&lang=ts&"
export * from "./updateLiquidationModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports